module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/accessories-v2-da3fd555325200daa747931a54be782c.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/accessories-v2.svg
// module id = J1Qe
// module chunks = 1 3 10 12 18